import dayjs from "dayjs";
import "dayjs/locale/tr";
import "dayjs/locale/fr";
import "dayjs/locale/de";
import "dayjs/locale/es";
import "dayjs/locale/zh-cn";
import "dayjs/locale/en"; // opsiyonel ama açık dursun

import {
  Box,
  Grid,
  Card,
  useMediaQuery,
  ThemeProvider,
  TextField,
  useTheme,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  TableHeaders,
  TableHeadersMd,
  TableHeadersSm,
} from "../TableHeaders/TableHeaders";
import DashboardTable from "./DashboardTable";
import PerformanceCards from "./Performances/PerformanceCards";
import ApexChart2 from "./Charts/ApexChart2";
import DateRangeContext from "../../contexts/Dashboard/DateRange";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TopBookedCountries from "./TopBookedCountries/TopBookedCountries";
import RecentActivities from "./RecentActivities/RecentActivities";
import ProviderWrapperArea from "./Deals/Map/ProviderWrapperArea";
import TestChart from "./Charts/TestChart";

import ProgressBar from "./ProgressBar/ProgressBar";

import TotalSalesIconImg from "../../assets/images/icons/TotalSalesIcon.svg";
import TotalInvoicesIconImg from "../../assets/images/icons/TotalInvoicesIcon.svg";
import BookedStudentsImg from "../../assets/images/icons/BookedStudents.svg";
import PartiallyPaidInvoicesImg from "../../assets/images/icons/PartiallyPaidInvoices.svg";
import PaidInvoicesImg from "../../assets/images/icons/PaidInvoices.svg";
import OverdueInvoicesImg from "../../assets/images/icons/OverdueInvoices.svg";
import SliderTopArea from "./SliderTopArea/SliderTopArea";
import BookingTheGap from "./BookingTheGap";
import { useTranslation } from "react-i18next";

// import ProgressBar from "./ProgressBar/ProgressBar";

export default function DashboardMain({
  open,
  setOpen,
  isMobile,
  setIsMobile,
}) {

  const { t, i18n } = useTranslation();

  const generateCards = (existingValues = {}) => [
    {
      name: t("totalSales"),
      id: "total_sales",
      value: existingValues["total_sales"] || "",
      icon: TotalSalesIconImg,
    },
    {
      name: t("totalInvoices"),
      id: "total_invoices",
      value: existingValues["total_invoices"] || "",
      icon: TotalInvoicesIconImg,
    },
    {
      name: t("bookedStudents"),
      id: "total_students",
      value: existingValues["total_students"] || "",
      icon: BookedStudentsImg,
    },
    {
      name: t("paidInvoices"),
      id: "total_paid_invoices",
      value: existingValues["total_paid_invoices"] || "",
      icon: PaidInvoicesImg,
    },
    {
      name: t("partiallyPaidInvoices"),
      id: "total_partially_paid_invoices",
      value: existingValues["total_partially_paid_invoices"] || "",
      icon: PartiallyPaidInvoicesImg,
    },
    {
      name: t("overdueInvoices"),
      id: "total_overdue_invoices",
      value: existingValues["total_overdue_invoices"] || "",
      icon: OverdueInvoicesImg,
    },
    {
      name: t("pendingDeposit"),
      id: "deposit_pending_quotes",
      value: existingValues["deposit_pending_quotes"] || "",
      icon: TotalInvoicesIconImg,
    },
    {
      name: t("totalQuotes"),
      id: "total_quotes",
      value: existingValues["total_quotes"] || "",
      icon: TotalInvoicesIconImg,
    },
  ];


  /*  const cardsInit = [
     {
       name: t("totalSales"),
       id: "total_sales",
       value: "",
       icon: TotalSalesIconImg,
     },
     {
       name: t("totalInvoices"),
       id: "total_invoices",
       value: "",
       icon: TotalInvoicesIconImg,
     },
     {
       name: t("bookedStudents"),
       id: "total_students",
       value: "",
       icon: BookedStudentsImg,
     },
     {
       name: t("paidInvoices"),
       id: "total_paid_invoices",
       value: "",
       icon: PaidInvoicesImg,
     },
     {
       name: t("partiallyPaidInvoices"),
       id: "total_partially_paid_invoices",
       value: "",
       icon: PartiallyPaidInvoicesImg,
     },
     {
       name: t("overdueInvoices"),
       id: "total_overdue_invoices",
       value: "",
       icon: OverdueInvoicesImg,
     },
     {
       name: t("pendingDeposit"),
       id: "deposit_pending_quotes",
       value: "",
       icon: TotalInvoicesIconImg,
     },
     {
       name: t("totalQuotes"),
       id: "total_quotes",
       value: "",
       icon: TotalInvoicesIconImg,
     },
     // {
     //   name: "Total Commissions",
     //   id: "total_commissions",
     //   value: "",
     //   icon: CurrencyPoundIcon,
     // },
 
   ]; */

  const theme = useTheme();
  const isMobileSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobileMd = useMediaQuery(theme.breakpoints.down("md"));

  const [tableHeaderBookings, setTableHeaderBookings] = useState([]);
  const [, setTableHeaderInvoices] = useState([]);
  const [loadingProfile, setLoadingProfile] = useState(true);



  useEffect(() => {
    dayjs.locale(i18n.language === "cn" ? "zh-cn" : i18n.language);

    setCards((prevCards) =>
      generateCards(
        Object.fromEntries(prevCards.map((item) => [item.id, item.value]))
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  const [cards, setCards] = useState(() => generateCards());
  const [allTableHeaderBookings, setAllTableHeaderBookings] = useState(null);
  const [, setAllTableHeaderInvoices] = useState(null);
  const [tableCardRefControl, setTableCardRefControl] = useState({
    bool: false,
    type: null,
  });

  const { startDate, setStartDate, endDate, setEndDate } =
    useContext(DateRangeContext);

  const tableCardRef = useRef();

  // #region agent log
  const measure = React.useCallback(() => {
    const doc = document.documentElement;
    const body = document.body;
    const root = document.querySelector('[data-root-layout]');
    const main = document.querySelector('[data-main-content]');
    const container = document.querySelector('.MuiContainer-root');
    const gridContainers = document.querySelectorAll('.MuiGrid-container');
    const payload = {
      sessionId: 'fad808',
      hypothesisId: 'A',
      location: 'DashboardMain.jsx:measure',
      message: 'overflow-measure',
      data: {
        loadingProfile,
        docScrollWidth: doc?.scrollWidth,
        docClientWidth: doc?.clientWidth,
        docOverflow: doc?.scrollWidth > doc?.clientWidth,
        rootScrollWidth: root?.scrollWidth,
        rootClientWidth: root?.clientWidth,
        rootOverflow: root ? root.scrollWidth > root.clientWidth : null,
        mainScrollWidth: main?.scrollWidth,
        mainClientWidth: main?.clientWidth,
        mainOverflow: main ? main.scrollWidth > main.clientWidth : null,
        containerScrollWidth: container?.scrollWidth,
        containerClientWidth: container?.clientWidth,
        containerOverflow: container ? container.scrollWidth > container.clientWidth : null,
        gridCount: gridContainers?.length,
        grids: Array.from(gridContainers || []).slice(0, 5).map((g, i) => ({ i, sw: g.scrollWidth, cw: g.clientWidth, overflow: g.scrollWidth > g.clientWidth })),
        innerWidth: window.innerWidth,
      },
      timestamp: Date.now(),
    };
    fetch('http://127.0.0.1:7524/ingest/73aca20c-1033-4d30-83db-a25a8500dd41', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': 'fad808' }, body: JSON.stringify(payload) }).catch(() => {});
  }, [loadingProfile]);
  useEffect(() => {
    const t = setTimeout(measure, 500);
    const ro = new ResizeObserver(() => { measure(); });
    const main = document.querySelector('[data-main-content]');
    if (main) ro.observe(main);
    return () => { clearTimeout(t); ro.disconnect(); };
  }, [measure]);
  useEffect(() => {
    if (!loadingProfile) {
      const t1 = setTimeout(measure, 100);
      const t2 = setTimeout(measure, 500);
      const t3 = setTimeout(measure, 1000);
      return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
    }
  }, [loadingProfile, measure]);
  // #endregion

  // Bookings için useEffect
  useEffect(() => {
    const tableHeaderDataBookings = TableHeaders.find(
      (header) => "bookings" in header
    )["bookings"];
    let newTableHeaderBookings = tableHeaderDataBookings;
    setAllTableHeaderBookings(newTableHeaderBookings);
    if (isMobileSm) {
      newTableHeaderBookings = TableHeadersSm.find(
        (header) => "bookings" in header
      )["bookings"];
    } else if (isMobileMd) {
      newTableHeaderBookings = TableHeadersMd.find(
        (header) => "bookings" in header
      )["bookings"];
    } else if (tableCardRefControl.bool) {
      if (tableCardRefControl.type === "md") {
        newTableHeaderBookings = TableHeadersMd.find(
          (header) => "bookings" in header
        )["bookings"];
      } else if (tableCardRefControl.type === "sm") {
        newTableHeaderBookings = TableHeadersSm.find(
          (header) => "bookings" in header
        )["bookings"];
      }
    }

    setTableHeaderBookings(newTableHeaderBookings);
  }, [isMobileSm, isMobileMd, tableCardRefControl]);

  // Invoices için useEffect
  useEffect(() => {
    const tableHeaderDataInvoices = TableHeaders.find(
      (header) => "commissions" in header
    )["commissions"];
    let newTableHeaderInvoices = tableHeaderDataInvoices;
    setAllTableHeaderInvoices(newTableHeaderInvoices);
    if (isMobileSm) {
      newTableHeaderInvoices = TableHeadersSm.find(
        (header) => "commissions" in header
      )["commissions"];
    } else if (isMobileMd) {
      newTableHeaderInvoices = TableHeadersMd.find(
        (header) => "commissions" in header
      )["commissions"];
    }

    setTableHeaderInvoices(newTableHeaderInvoices);
  }, [isMobileSm, isMobileMd]);

  useEffect(() => {
    if (
      tableCardRef?.current?.offsetWidth < 1000 &&
      tableCardRef?.current?.offsetWidth >= 500
    ) {
      setTableCardRefControl({ bool: true, type: "md" });
    } else if (tableCardRef?.current?.offsetWidth < 500) {
      setTableCardRefControl({ bool: true, type: "sm" });
    }
    const handleResize = () => {
      if (
        tableCardRef?.current?.offsetWidth < 1000 &&
        tableCardRef?.current?.offsetWidth >= 500
      ) {
        setTableCardRefControl({ bool: true, type: "md" });
      } else if (tableCardRef?.current?.offsetWidth < 500) {
        setTableCardRefControl({ bool: true, type: "sm" });
      } else {
        setTableCardRefControl(false, null);
      }
    };
    window.addEventListener("resize", handleResize);
  }, []);
  // useEffect(() => {
  //   const tableHeaderData = TableHeaders.find((header) => "bookings" in header)[
  //     "bookings"
  //   ];
  //   setAllTableHeader(tableHeaderData);
  //   if ("bookings" !== "invoices") {
  //     const tableHeaderSmData = TableHeadersSm.find(
  //       (header) => "bookings" in header
  //     )["bookings"];

  //     const tableHeaderMdData = TableHeadersMd.find(
  //       (header) => "bookings" in header
  //     )["bookings"];

  //     if (tableHeaderData) {
  //       let newTableHeader = [...tableHeaderData]; // tableHeader'ı kopyalayarak başlayın

  //       if (isMobileSm) {
  //         newTableHeader = tableHeaderSmData;
  //       } else if (isMobileMd) {
  //         newTableHeader = tableHeaderMdData;
  //       }

  //       setTableHeader(newTableHeader);
  //     } else {
  //     }
  //   }
  // }, [isMobileSm, isMobileMd]);

  // useEffect(() => {
  //   if (profile?.account_type === "main_branch") {
  //     let newCards = cardsInit.filter((item) => {
  //       return item.id !== "total_commissions";
  //     });
  //     setCards(newCards);
  //   } else {
  //     setCards(cardsInit);
  //   }
  // }, [profile]);
  return (
    <ThemeProvider theme={theme}>
      <Box>
        {/* <Typography
          className="title"
          variant="h4"
          fontWeight={700}
          color={theme.palette.customRed.orange}
        >
          Dashboard
        </Typography>

        <BreadCrumbs routs={["Dashboard"]} component={"dashboard"} /> */}

        <Box sx={{ marginTop: "0rem" }}>
          <Grid container spacing={3}>
            {/* <Grid item xs={12} md={6} marginLeft={"auto"}>
              <ProgressBar />
            </Grid> */}

            <Grid item xs={12}>
              <SliderTopArea />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={6}>
                  <Box
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: { xs: "column", lg: "row" },
                      rowGap: { xs: 2, lg: 0 },
                      columnGap: { xs: 0, lg: 2 },
                    }}
                  >
                    <Box sx={{ width: "100%" }}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale={i18n.language === "cn" ? "zh-cn" : i18n.language}>
                        <DatePicker
                          sx={{ width: "100%" }}
                          label={t("startDate")}
                          value={startDate}
                          onChange={setStartDate}
                          renderInput={(params) => <TextField {...params} />}
                          maxDate={endDate}
                        />
                      </LocalizationProvider>
                    </Box>

                    <Box
                      sx={{
                        width: "100%",
                        // marginTop: { xs: "1rem", md: "1rem" },
                      }}
                    >
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale={i18n.language === "cn" ? "zh-cn" : i18n.language}>
                        <DatePicker
                          sx={{ width: "100%" }}
                          label={t("endDate")}
                          value={endDate}
                          onChange={setEndDate}
                          renderInput={(params) => <TextField {...params} />}
                          minDate={startDate}
                        />
                      </LocalizationProvider>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} lg={6}>
                  <ProgressBar barType="dashboard" />
                </Grid>
              </Grid>
              {/* <Box
                sx={{
                  borderRadius: "1rem",
                  background: lightMode ? "#ffffff" : "#292929",
                }}
              >
               
              </Box> */}
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={3}>
                <PerformanceCards
                  loadingProfile={loadingProfile}
                  setLoadingProfile={setLoadingProfile}
                  cards={cards}
                  setCards={setCards}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={3} sx={{ marginTop: "2rem" }}>
            <Grid item xs={12} lg={12}>
              <Card
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  pb: 4,
                  // background: lightMode ? "#ffffff" : "#292929",
                }}
              >
                {/* <PieChart
                  colors={[
                    "#23416a",
                    getTheme().palette.customRed.dark,
                    getTheme().palette.customRed.extraDark,
                  ]}
                  series={[
                    {
                      data: [
                        { id: 0, value: 10, label: "series A" },
                        { id: 1, value: 15, label: "series B" },
                        { id: 2, value: 20, label: "series C" },
                      ],
                    },
                  ]}
                  width={400}
                  height={200}
                /> */}
                {/* <PieChartComp /> */}
                <ApexChart2 />
              </Card>
            </Grid>
            {/* <Grid item xs={12} lg={5}>
              <Card
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "1.5rem 1rem",
                  // background: lightMode ? "#ffffff" : "#292929",
                }}
              >
                <SliderArea />
                // <CardMedia
                //   component="iframe"
                //   height="100%" // İhtiyacınıza göre ayarlayın
                //   image="https://www.youtube.com/embed/t_jmqnFsKkw?si=IOpd7I-jqlscYcTT" // YOUR_VIDEO_ID yerine YouTube video ID'nizi girin
                //   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                //   title="Embedded YouTube Video"
                // />
              </Card>
            </Grid> */}

            {/* {profile?.agency_type !== "Institution" &&
            profile?.account_type === "main_branch" ? (
              <Grid item xs={12} lg={12} xl={12}>
                <Card
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "1.5rem 1rem",
                  }}
                >
                  <TotalCommissions />
                </Card>
              </Grid>
            ) : null} */}

            <Grid item xs={12}>
              <TopBookedCountries open={open} />
            </Grid>

            <Grid item xs={12} md={12}>
              <Card
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                }}
              >
                {/* <LineChart
                  xAxis={[{ data: [1, 2, 3, 5, 8, 10] }]}
                  series={[
                    {
                      data: [2, 5.5, 2, 8.5, 1.5, 5],
                      color: "#23416a",
                    },
                  ]}
                  width={500}
                  height={300}
                /> */}
                {/* <LineChartComp /> */}
                {/* <BarChartComp /> */}
                {/* <ApexChart /> */}
                <TestChart />
              </Card>
            </Grid>
            {/* <Grid item xs={12} md={6}>
              <Card
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "1.5rem 1rem",
                }}
              >
                //  <PieChart
                //   colors={[
                //     "#23416a",
                //     getTheme().palette.customRed.dark,
                //     getTheme().palette.customRed.extraDark,
                //   ]}
                //   series={[
                //     {
                //       data: [
                //         { id: 0, value: 10, label: "series A" },
                //         { id: 1, value: 15, label: "series B" },
                //         { id: 2, value: 20, label: "series C" },
                //       ],
                //     },
                //   ]}
                //   width={400}
                //   height={200}
                // />
                <PieChartComp />
              </Card>
            </Grid> */}
            <Grid item xs={12} lg={12}>
              <Card
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: 0,
                }}
              >
                <ProviderWrapperArea
                  open={open}
                  setOpen={setOpen}
                  isMobile={isMobile}
                  setIsMobile={setIsMobile}
                />
                {/* <MyMap /> */}
              </Card>
            </Grid>
            {/* COMMISSION CHANGED */}
            <Grid item xs={12} lg={12}>
              <Card
                ref={tableCardRef}
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0,
                }}
              >
                <DashboardTable
                  tableHeader={tableHeaderBookings}
                  allTableHeader={allTableHeaderBookings}
                  isMobileSm={isMobileSm}
                  isMobileMd={isMobileMd}
                  tableType={"bookings"}
                  tableCardRefControl={tableCardRefControl}
                />
              </Card>
            </Grid>

            {/* {profile?.account_type === "main_branch" &&
            profile?.agency_type !== "Institution" ? (
              <Grid item xs={12}>
                <Card
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "1rem",
                  }}
                >
                  <DashboardTable
                    tableHeader={tableHeaderInvoices}
                    allTableHeader={allTableHeaderInvoices}
                    isMobileSm={isMobileSm}
                    isMobileMd={isMobileMd}
                    tableType={"commissions"}
                  />
                </Card>
              </Grid>
            ) : null} */}

            {/* {profile?.account_type === "main_branch" ? (
              <Grid item xs={12}>
                <Card
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "1rem",
                  }}
                >
                  <DashboardTable
                    tableHeader={tableHeaderInvoices}
                    allTableHeader={allTableHeaderInvoices}
                    isMobileSm={isMobileSm}
                    isMobileMd={isMobileMd}
                    tableType={"commissions"}
                  />
                </Card>
              </Grid>
            ) : null} */}

            <Grid item xs={12}>
              <Card>
                <RecentActivities />
              </Card>
            </Grid>
            {/* <Grid item xs={12}>
              <Card
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "1rem 1rem 3rem 1rem",
                }}
              >
                <RecentActivities />
              </Card>
            </Grid> */}

            <Grid item xs={12}>
              <Card>
                {/* <BestDeals /> */}
                <BookingTheGap />
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
